import { motion } from "framer-motion";

interface TeclyPullRefreshProps {
  pullDistance: number;
  isRefreshing: boolean;
  threshold?: number;
}

const TeclyPullRefresh = ({ pullDistance, isRefreshing, threshold = 80 }: TeclyPullRefreshProps) => {
  const progress = Math.min(pullDistance / threshold, 1);
  const showIndicator = isRefreshing || pullDistance > 10;

  if (!showIndicator) return null;

  return (
    <div
      className="flex items-center justify-center overflow-hidden"
      style={{
        height: isRefreshing ? 56 : pullDistance > 10 ? pullDistance : 0,
        transition: isRefreshing ? "height 0.3s ease-out" : "none",
      }}
    >
      <motion.div
        className="relative flex items-center justify-center"
        animate={isRefreshing ? { rotate: 360 } : { rotate: pullDistance * 2.5 }}
        transition={
          isRefreshing
            ? { repeat: Infinity, duration: 1, ease: "linear" }
            : { type: "spring", stiffness: 300, damping: 30 }
        }
      >
        {/* Outer progress ring */}
        <svg width="38" height="38" viewBox="0 0 38 38" className="absolute">
          <circle
            cx="19"
            cy="19"
            r="16"
            fill="none"
            stroke="hsl(var(--primary) / 0.15)"
            strokeWidth="2.5"
          />
          <motion.circle
            cx="19"
            cy="19"
            r="16"
            fill="none"
            stroke="hsl(var(--primary))"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray={100.5}
            strokeDashoffset={isRefreshing ? 25 : 100.5 - progress * 100.5}
            style={{ transformOrigin: "center", transform: "rotate(-90deg)" }}
            animate={
              isRefreshing
                ? { strokeDashoffset: [75, 25, 75], opacity: [0.6, 1, 0.6] }
                : {}
            }
            transition={
              isRefreshing
                ? { repeat: Infinity, duration: 1.2, ease: "easeInOut" }
                : {}
            }
          />
        </svg>
        {/* Inner circle with T */}
        <motion.div
          className="relative flex items-center justify-center rounded-full bg-background border border-primary/20 shadow-md dark:border-primary/30"
          style={{ width: 32, height: 32 }}
          animate={
            isRefreshing
              ? { scale: [1, 0.92, 1] }
              : { scale: 0.7 + progress * 0.3 }
          }
          transition={
            isRefreshing
              ? { repeat: Infinity, duration: 1, ease: "easeInOut" }
              : { type: "spring", stiffness: 300, damping: 25 }
          }
        >
          <span
            className="font-black text-base text-primary select-none"
            style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.02em" }}
          >
            T
          </span>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default TeclyPullRefresh;
